// extracted by mini-css-extract-plugin
module.exports = {"autoTooltip":"autoTooltip__MGeqJ","active":"active__HwKyC","content":"content__OA6S9","tooltip":"tooltip__BjoAT"};